import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ShareIcon from '@mui/icons-material/Share';
import { Box, Tooltip } from '@mui/material';
import React from 'react';
import { CircularActionIcon } from '../styles/styles';
import { StyledButton } from '../styles/StyledButtons';

type FundOpportunityHeaderActionsProps = {
  onCreateAppointment: () => void;
  onSendMessage: () => void;
  onShare: () => void;
  downloadPDF: () => void;
  showDownloadPdf?: boolean;
};

export default function FundOpportunityHeaderActions({
  onCreateAppointment,
  onSendMessage,
  onShare,
  downloadPDF,
  showDownloadPdf = true,
}: FundOpportunityHeaderActionsProps) {
  return (
    <Box display="flex" alignItems="center" gap={1} sx={{ px: { xs: '1.875rem', lg: 0 } }}>
      <Tooltip title="Create Appointment">
        <CircularActionIcon onClick={onCreateAppointment}>
          <CalendarTodayIcon />
        </CircularActionIcon>
      </Tooltip>
      <Tooltip title="Send Message">
        <CircularActionIcon onClick={onSendMessage}>
          <MailOutlineIcon />
        </CircularActionIcon>
      </Tooltip>
      <StyledButton noTopSpacing onClick={onShare} startIcon={<ShareIcon />}>
        Share
      </StyledButton>
      {showDownloadPdf && (
        <StyledButton noTopSpacing onClick={downloadPDF}>
          Download PDF
        </StyledButton>
      )}
    </Box>
  );
}
